import { $isLinkNode, LinkNode } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $findMatchingParent,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  SELECTION_CHANGE_COMMAND,
} from 'lexical';
import { useEffect, useState } from 'react';

export const useSelectedLinkNode = () => {
  const [editor] = useLexicalComposerContext();
  const [linkNode, setLinkNode] = useState<LinkNode | null>(null);

  useEffect(() => {
    return editor.registerCommand(
      SELECTION_CHANGE_COMMAND,
      () => {
        editor.read(() => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) {
            setLinkNode(null);
            return;
          }
          const node = selection.anchor.getNode();
          const found = $findMatchingParent(node, $isLinkNode);
          setLinkNode(found);
        });
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return linkNode;
};
